/**
 * Clamps a value between a minimum and maximum value.
 *
 * 指定された値が最小値と最大値の範囲内に収まるように調整。
 *
 * @param value The value to clamp. / クランプする値。
 * @param min The minimum value. / 最小値。
 * @param max The maximum value. / 最大値。
 * @returns The clamped value. / クランプされた値。
 */
export const minmax = (value: number, min: number, max: number): number => {
    return Math.min(max, Math.max(min, value))
}
